import { PaymentType } from './order';

export const getPaymentTypeLabel = (value: PaymentType, newPolicyActive: boolean): string => {
    switch (value) {
        case PaymentType.Card: return newPolicyActive ? 'Debit/Credit Card' : 'Debit Card';
        case PaymentType.Cash: return 'Cash';
        case PaymentType.Cheque: return 'Cheque';
        case PaymentType.DirectDeposit: return 'Direct Deposit';
        case PaymentType.Merchant: return 'Credit Card';
        case PaymentType.SquareLink: return 'Square Link';
        default: return '';
    }
};

export const getPaymentOptions = (newPolicyActive: boolean): PaymentType[] =>
    newPolicyActive
        ? [PaymentType.Card, PaymentType.Cash, PaymentType.SquareLink, PaymentType.DirectDeposit]
        : [PaymentType.Card, PaymentType.Merchant, PaymentType.Cash, PaymentType.Cheque, PaymentType.DirectDeposit];
